// --- START OF FILE Courses.js ---

import React, { useEffect, useState } from 'react';
import CourseCard from '../components/CourseCard.js'; // Make sure this path is correct for your project

const CoursesPage = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

  useEffect(() => {
    const fetchAllCourses = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/courses`); // Fetch all courses
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setCourses(data);
      } catch (err) {
        console.error('Error fetching all courses:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAllCourses();
  }, [API_BASE_URL]); // Dependency on API_BASE_URL

  return (
    <div className="container mx-auto px-4 py-12">
      <h2 className="text-4xl font-extrabold text-gray-900 text-center mb-12 leading-tight">
        Danh sách khóa học
      </h2>

      {loading ? (
        <div className="text-center py-20">
          <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-purple-600 mx-auto mb-5"></div>
          <p className="text-2xl text-gray-700">Đang tải danh sách khóa học...</p>
        </div>
      ) : error ? (
        <div className="text-center py-20">
          <p className="text-2xl text-red-600 font-semibold">Lỗi khi tải khóa học</p>
          <p className="text-lg text-gray-600 mt-3">Có lỗi xảy ra: {error}</p>
          <p className="text-gray-600 mt-2">Vui lòng thử lại sau.</p>
        </div>
      ) : courses.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {courses.map((course) => (
            <CourseCard key={course.id} course={course} />
          ))}
        </div>
      ) : (
        <div className="col-span-full text-center text-gray-600 text-xl py-20">
          Rất tiếc, hiện tại chưa có khóa học nào. Vui lòng quay lại sau!
        </div>
      )}
    </div>
  );
};

export default CoursesPage;
// --- END OF FILE Courses.js ---